import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import React, { useEffect, useState } from "react";
import {
  getTabRechargeTransactionsDetails,
  getTabRechargeTransactionsList,
} from "../../../../service/profile-ras-service";

import { DatePicker } from "antd";
import Loading from "../../../loader/loader.js";
import NkTable from "../../nktable";
import RechargeTransactionFilter from "../modals/recharge-tansactions-filter";
import RechargeTransactionModal from "../modals/rechargetransactionmodal";
import moment from "moment";
import { useLocation } from "react-router-dom";

const RechargeTransactionsTab = ({ userId, allUsersObject }) => {
  const [transactionModal, setTransactionModal] = useState(false);
  const [searchBy, setSearchBy] = useState("receiver");
  const [searchByValue, setSearchByValue] = useState("");
  const [filterValues, setFilterValues] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState();
  const [dataLoading, setDataLoading] = useState(false);
  const [filtersSelected, setFiltersSelected] = useState(false);
  const [allUserList, setAllUserList] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [rakTab, setRakTab] = useState([]);
  const [sizeShow, setSizeShow] = useState();
  const [type, setType] = useState([]);
  const [status, setStatus] = useState([]);
  const request = {
    page: 1,
    size: 10,
    beneficiaryName: null,
    receiver: null,
    fromDate: null,
    toDate: null,
    searchType: "",
    searchCountry: "",
    searchStatus: "",
    c3REF: null,
    rakRef: null,
    isFilter: false,
  };

  const { state } = useLocation();
  console.log(state);
  console.log(allUsersObject);
  const [filterForm, setFilterForm] = useState(request);

  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 0,
    current: 1,
  });
  const columns = [
    {
      dataField: "actions",
      text: "Actions",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "150px", textAlign: "center" },
      formatter: (cell, row) => {
        return (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              class="fas fa-file "
              style={{ fontSize: 20 }}
              onClick={() => {
                if (row && row.id) {
                  handleTransactionDetails(row.id);
                }
              }}
            ></i>
          </div>
        );
      },
    },
    {
      dataField: "createdDate",
      text: "Date",
      sort: true,
      style: { minWidth: "100px", textAlign: "Left" },
      formatter: (cell, row) => {
        // return moment((row && row.createdDate) || null).format("DD-MM-YY");
        return moment((row && row.createdDate) || null).format(
          "DD-MM-YY HH:mm:ss"
        );
      },
    },
    {
      dataField: "beneficiary",
      text: "Beneficiary",
      sort: false,
      style: { minWidth: "150px", textAlign: "left" },
    },
    {
      dataField: "receiver",
      text: "Receiver",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "150px", textAlign: "center" },
    },
    {
      dataField: "send",
      text: "Send(AED)",
      sort: false,
      style: { minWidth: "100px", textAlign: "center" },
      headerStyle: { textAlign: "centers" },
    },
    {
      dataField: "partnerReference",
      text: "DING Number",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "130px", textAlign: "center" },
    },

    {
      dataField: "status",
      text: "Status",
      sort: false,
      headerStyle: { textAlign: "left" },
      style: { minWidth: "150px", textAlign: "left" },
    },
    {
      dataField: "type",
      text: "Type",
      sort: false,
      headerStyle: { textAlign: "left" },
      style: { minWidth: "150px", textAlign: "left" },
      formatter: (cell, row) => {
        console.log(row);
        return (
          <div>
            {row && row.type === "CALLINGCARDS" ? "LOCAL" : row && row.type}
          </div>
        );
      },
    },
    {
      dataField: "c3REF",
      text: "C3Ref",
      sort: false,
      headerStyle: { textAlign: "left" },
      style: { minWidth: "150px", textAlign: "left" },
    },
  ];

  const handleFilter = () => {
    let request = {};
    request["searchType"] =
      request && request.searchType && request.searchType.length == 0
        ? ""
        : request.searchType;
    request["searchStatus"] =
      request && request.searchStatus && request.searchStatus.length == 0
        ? ""
        : request.searchStatus;
    console.log(searchBy);
    if (searchBy === "receiver") {
      request = {
        ...filterForm,
        receiver: searchByValue,
        beneficiaryName: "",
        c3REF: "",
      };
    } else if (searchBy === "beneficiary") {
      request = {
        ...filterForm,
        beneficiaryName: searchByValue,
        receiver: "",
        c3REF: "",
      };
    } else if (searchBy === "c3ref") {
      request = {
        ...filterForm,
        c3REF: searchByValue,
        beneficiaryName: "",
        receiver: "",
      };
    }
    if (
      filterForm &&
      filterForm.searchType &&
      filterForm.searchType.length > 0
    ) {
      let a = "";
      filterForm &&
        filterForm.searchType &&
        filterForm.searchType.forEach((v, i) => {
          console.log(v);
          a = a + v.value + (i + 1 < filterForm.searchType.length ? "," : "");
        });
      request.searchType = a || "";
    } else {
      request.searchType = filterForm.searchType || "";
    }
    if (
      filterForm &&
      filterForm.searchStatus &&
      filterForm.searchStatus.length > 0
    ) {
      let a = "";
      filterForm &&
        filterForm.searchStatus.forEach((v, i) => {
          console.log(v);
          a = a + v.value + (i + 1 < filterForm.searchStatus.length ? "," : "");
        });
      request.searchStatus = a || "";
    } else {
      request.searchStatus = filterForm.searchStatus || "";
    }

    request.fromDate =
      (fromDate && moment(fromDate).format("YYYY-MM-DD")) || null;
    request.toDate =
      (toDate && moment(toDate).format("YYYY-MM-DD")) || moment().format();

    request.searchFilter = "";
    request.page = 1;
    request.isFilter = true;

    setFilterForm(request);
    console.log(searchByValue);
    console.log(request);
  };

  const [id, setId] = useState();

  useEffect(() => {
    if (userId) {
      setId(userId);
    }
  }, []);

  useEffect(() => {
    if (id) {
      getTabRechargeTransactionListDD(filterForm, id);
    }
  }, [id]);

  useEffect(() => {
    if (filterForm && filterForm.isFilter) {
      getTabRechargeTransactionListDD(filterForm, id);
    }
  }, [filterForm]);

  const getTabRechargeTransactionListDD = (request, id) => {
    setDataLoading(true);
    request["searchStatus"] =
      request.searchStatus.length == 0 ? "" : request.searchStatus;
    request["searchType"] =
      request.searchType.length == 0 ? "" : request.searchType;
    console.log(request);
    request.size = sizeShow || 10;
    getTabRechargeTransactionsList(request, id)
      .then((res) => {
        setDataLoading(false);
        setRakTab(res.data.rechargeTransactions || []);
        setPagination({
          ...pagination,
          pageSize: sizeShow || 10,
          total: res.data.totalCount,
          current: request.page,
        });
      })
      .catch((err) => {
        setPagination({ ...pagination, pageSize: 10, total: 0, current: 1 });
        setDataLoading(false);
        console.log(err);
        setRakTab([]); // TODO -NEED TO REMOVE
      });
  };
  const [transactionDetail, setTransactionDetail] = useState([]);

  const handleTransactionDetails = (id) => {
    getTabRechargeTransactionsDetails(id)
      .then((res) => {
        setTransactionModal(true);
        setTransactionDetail(res && res.data);
        console.log(res);
      })
      .catch((err) => {
        setTransactionModal(false);
        setTransactionDetail([]);
      });
  };

  let searchByValuePlaceholder = "";
  if (searchBy === "beneficiary") {
    searchByValuePlaceholder = "Amit Pandit";
  } else if (searchBy === "receiver") {
    searchByValuePlaceholder = "971507878961";
  } else if (searchBy === "c3ref") {
    searchByValuePlaceholder = "432325";
  }

  const resetFilter = () => {
    request.isFilter = true;
    setType([]);
    setStatus([]);
    setFilterForm(request);
    setFiltersSelected(false);
    setRakTab([]);
    setFromDate("");
    setToDate("");
    setFilterValues(false);
    setSearchBy("receiver");
    setSearchByValue("");
  };

  const clearFilter = () => {
    setFilterForm({
      ...filterForm,
      searchType: "",
      searchStatus: "",
      typeLength: 0,
      statusLength: 0,
      totalLength: 0,
    });
    setType([]);
    setStatus([]);
  };

  const dateFormat = "DD-MM-YY";
  const customFormat = (value) => `${value.format(dateFormat)}`;
  return (
    <>
      <Row
        style={{ marginLeft: "0px", marginRight: "0px", padding: "12px 0px" }}
      >
        <Col lg="2" className="form-input-padding-tab">
          <FormGroup>
            <label
              className="form-control-label"
              htmlFor="exampleFormControlSelect1"
            >
              Search by
            </label>
            <Input
              id="exampleFormControlSelect1"
              style={{ height: "28px" }}
              type="select"
              value={searchBy}
              onChange={(e) => {
                setSearchByValue("");
                setSearchBy(e.target.value);
                console.log(e.target.value);
              }}
            >
              <option value="receiver">Receiver</option>
              <option value="c3ref">C3Ref</option>
              <option value="beneficiary">Beneficiary</option>
            </Input>
          </FormGroup>
        </Col>
        <Col lg="2" className="form-input-padding-tab">
          <FormGroup>
            <label className="form-control-label" htmlFor="example3cols2Input">
              Search for
            </label>
            <Input
              id="example3cols2Input"
              placeholder={searchByValuePlaceholder}
              type="text"
              style={{ height: "27px" }}
              onKeyPress={(e) => e.charCode === 13 && handleFilter(true)}
              onChange={(e) =>
                setSearchByValue(
                  e.target && e.target.value && e.target.value.trim()
                )
              }
              value={searchByValue}
            />
          </FormGroup>
        </Col>
        <Col lg="2" className="form-input-padding-tab">
          <FormGroup>
            <Label className="form-control-label" htmlFor="example3cols2Input">
              From
            </Label>
            <DatePicker
              placeholder="DD-MM-YY"
              className="formcontrol-date"
              onChange={(e, dateString) => {
                if (dateString && dateString != "") {
                  setFromDate(moment(dateString, dateFormat));
                } else {
                  setFromDate(null);
                }
              }}
              value={fromDate}
              format={customFormat}
            />
          </FormGroup>
        </Col>
        <Col lg="2" className="form-input-padding-tab">
          <FormGroup>
            <Label className="form-control-label" htmlFor="example3cols2Input">
              To
            </Label>
            <DatePicker
              placeholder="DD-MM-YY"
              className="formcontrol-date"
              onChange={(e, dateString) => {
                if (dateString && dateString != "") {
                  setToDate(moment(dateString, dateFormat));
                } else {
                  setToDate(null);
                }
              }}
              value={toDate}
              format={customFormat}
            />
          </FormGroup>
        </Col>
        <div
          lg="1"
          className="form-input-padding-tab"
          style={{ marginTop: "2px" }}
        >
          <FormGroup>
            <Label
              className="form-control-label"
              htmlFor="exampleFormControlSelect1"
            >
              Filter by
            </Label>
            <div>
              <Button
                style={{ width: "100%", height: "26px" }}
                color="primary"
                type="button"
                id="example3cols2Input"
                className="filter-button"
                onClick={() => setShowFilterModal(true)}
              >
                <div>
                  {" "}
                  <i class="fas fa-filter"></i>
                </div>
              </Button>
            </div>
          </FormGroup>

          <span style={{ fontSize: 8 }}>
            {filterForm && filterForm.totalLength > 0 ? (
              <>
                <h6 style={{ display: "flex", alignItems: "center" }}>
                  selected(
                  {filterForm.totalLength}
                  )
                  <i
                    class="fas fa-window-close"
                    style={{ cursor: "pointer", paddingLeft: "5px" }}
                    onClick={() => clearFilter()}
                  />
                </h6>
              </>
            ) : (
              <></>
            )}
          </span>
        </div>
        <Col
          lg="1"
          style={{ marginTop: "9px" }}
          className="form-input-padding-tab"
        >
          <FormGroup>
            <Label
              className="form-control-label"
              htmlFor="example3cols2Input"
            ></Label>
            <div>
              <Button
                // color="#e91d24"
                type="button"
                style={{
                  width: "100%",
                  background: "#e91d24",
                  color: "white",
                  height: "26px",
                  border: "1px solid rgb(233, 29, 36)",
                }}
                id="example3cols2Input"
                className="filter-button"
                onClick={() => handleFilter()}
              >
                <div>
                  <i class="fas fa-search"></i>
                </div>
              </Button>
            </div>
          </FormGroup>
        </Col>
        <Col
          lg="1"
          style={{ marginTop: "9px" }}
          className="form-input-padding-tab"
        >
          <FormGroup>
            <Label
              className="form-control-label"
              htmlFor="example3cols2Input"
            ></Label>
            <div>
              <Button
                color="light"
                type="button"
                style={{ width: "100%", height: "26px" }}
                id="example3cols2Input"
                className="filter-button"
                onClick={() => resetFilter()}
              >
                <div
                  style={{
                    fontSize: "12px",
                  }}
                >
                  {" "}
                  <i class="fas fa-redo-alt 2px"></i> Reset
                </div>
              </Button>
            </div>
          </FormGroup>
        </Col>
      </Row>
      {rakTab.length < 0 ? (
        <>
          <Card
            className="mb-4"
            style={{
              display: "flex",
              flex: 1,
              textAlign: "center",
              justifyContent: "center",
              padding: "1.25rem 1.5rem",
            }}
          >
            <CardBody>
              <h3 className="mb-0"> No Records Found</h3>
              {/* <h1 className="mb-0">Sorry ! We cannot find it</h1>
              <h3 className="mb-0">
                Enter a different search term or remove any filters and try
                again
              </h3> */}
            </CardBody>
          </Card>
        </>
      ) : (
        <>
          <Row style={{ padding: "1.25rem 0.5rem" }}>
            <div className="col card-parent">
              <Card>
                {dataLoading ? (
                  <div style={{ textAlign: "center" }}>
                    <Loading />
                  </div>
                ) : (
                  <>
                    <NkTable
                      filename={"All-User-List"}
                      data={rakTab}
                      columns={columns}
                      pagination={pagination}
                      onPagechange={(page) => {
                        console.log(page);
                        setFilterForm({
                          ...filterForm,
                          page: page,
                          isFilter: true,
                        });
                        console.log(filterForm);
                      }}
                      showSizeChanged={(pageSize) => {
                        setSizeShow(pageSize);
                        setFilterForm({ ...filterForm, isFilter: true });
                      }}
                    />
                  </>
                )}
              </Card>
            </div>
          </Row>
        </>
      )}
      <RechargeTransactionFilter
        type={type}
        setType={setType}
        status={status}
        setStatus={setStatus}
        show={showFilterModal}
        onHide={() => {
          setShowFilterModal(false);
        }}
        saveButtonClicked={(saveResponse) => {
          console.log(saveResponse);
          setFilterForm({ ...filterForm, ...saveResponse, isFilter: false });
          setShowFilterModal(false);
        }}
      />
      <RechargeTransactionModal
        allUsersObject={allUsersObject}
        transactionDetail={transactionDetail}
        show={transactionModal}
        onHide={() => setTransactionModal(false)}
      />
    </>
  );
};
export default RechargeTransactionsTab;
